// extracted by mini-css-extract-plugin
module.exports = {"root":"Background_root__nQy4r","image":"Background_image__3flvf"};